<template>
  <div class="app-container">
    <el-dialog
      :title="title"
      :visible="visible"
      :width="width"
      append-to-body
      modal
      @close="handleCloes"
    >
      <BjPage
        ref="BjPage"
        :get-action="queryApi"
        :query-params="queryParams"
        :col-span="colSpan"
        :search-btn-span="colSpan"
        :serial="serial"
        :search-btn-hide="true"
        :before-reset-search="beforeResetSearch"
        :height="500"
        @afterFetchOriginalData="afterFetchOriginalData"
    >
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'dataStatus'">
                {{ $t(IMPORT_STATUS.bjGet(scope.row.dataStatus)) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { waveApi } from '@/api';
export default {
  name: 'History',
  mixins: [pageMiXin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%',
    },
  },
  data() {
    return {
      colSpan: 8,
      queryApi: waveApi.getWaveHistory,
      // 查询参数
      queryParams: {},
      labelList: [
        { label: 'SKU', prop: 'skuCode', isCheck: true, disabled: false,},
        { label: this.$t('screenWMS.order'), prop: 'outerOrderNo', isCheck: true, disabled: false,},
        { label: this.$t('screenWMS.scan'), prop: 'scanTime', isCheck: true, disabled: false,},
        { label: this.$t('screenWMS.Creator'), prop: 'creationBy', isCheck: true, disabled: false,},
      ],
    };
  },
  computed: {
    title() {
      return this.$t('screenWMS.allHis');
    },
  },
  watch: {
    visible: {
      handler(v) {
        if (v) {
         this.$nextTick(() => {
           this.$refs.BjPage.onSearch();
         });
      }
      }
    },
  },
  methods: {
    // 过滤页面数据
    afterFetchOriginalData(data) {
      data.content = data.records
      return data;
    },
    beforeResetSearch() {
      this.queryParams.waveId = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    handleCloes() {
      this.$emit('close');
    },
  }
};
</script>
